const ARG = 'AR';
const URU = 'URU';

export {
    ARG, URU
}